export default {
  publishToken: function () {
    return (
      new Date().getTime().toString(36) +
      '-' +
      Math.floor(1000 * Math.random()).toString(36)
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/services/token.js